export default function AboutUs() {
  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <img src="/logo.png" alt="EduAt10" style={logoStyle} />

          <h1>About EduAt10</h1>

          <h3>English</h3>
          <p>
            EduAt10 is an education-focused digital learning platform created
            with a mission to make quality education affordable and accessible
            for every student, especially those who cannot afford expensive
            tuition fees or costly books.
          </p>
          <p>
            Our platform allows students to study subject-wise topics, practice
            questions, and participate in scholarship exams at a very minimal
            cost.<a href="/pricing">View Pricing</a>
            
          </p>

          <h3>हिंदी</h3>
          <p>
            EduAt10 एक शिक्षा-केंद्रित डिजिटल लर्निंग प्लेटफॉर्म है, जिसे उन छात्रों
            के लिए बनाया गया है जो महंगी ट्यूशन फीस या किताबें खरीदने में सक्षम
            नहीं हैं।
          </p>
          <p>
            हमारा उद्देश्य न्यूनतम लागत पर विषयवार अध्ययन सामग्री, अभ्यास प्रश्न
            और स्कॉलरशिप परीक्षाओं की सुविधा प्रदान करना है। <a href="/pricing">View Pricing</a>
          </p>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  background: "rgba(0,0,0,0.25)",
  padding: 20,
};

const cardStyle = {
  background: "rgba(255,255,255,0.95)",
  maxWidth: 900,
  margin: "auto",
  padding: 30,
  borderRadius: 16,
};

const logoStyle = {
  width: 120,
  display: "block",
  margin: "0 auto 20px",
};
